
(function () {
  var selectors = {
    toggle: '[data-toggle-filters]',
    filters: '[data-collection-filters]',
    filtersList: '[data-collection-filters-list]',
    source: '[data-collection-filters] [data-filters-reset]',
    mirror: '[data-filters-reset-mirror]',
    filtersClearAll: '[data-filters-reset-mirror], [data-filters-reset]',
    stickyBar: '[data-collection-sticky-bar]',
    sortBar: '[data-sort-select-bar]',
    sortDrawer: '[data-sort-select-drawer]',
    nativeForm: '[data-collection-filters-form]',
    overlay: '[data-filters-overlay]',
    closeButton: '[data-close-filters]',
    filterBox: '.filter__box',
    filterBottomBox: '.filter-bottom-box',
  };
  var visibleClass = 'collection__filters--visible';
  var manyFiltersClass = 'collection__sticky-bar--many-filters';
  var manyFiltersThreshold = 4;

  // 현재 뷰포트가 데스크탑 기준(브레이크포인트 이상)인지 판별
  function isDesktop() {
    var breakpoint = (window.theme && theme.sizes && theme.sizes.small) || 768;
    return window.innerWidth >= breakpoint;
  }
  var suppressUntil = 0;
  window.ohrSuppressFiltersAutoOpen = function () {
    suppressUntil = Date.now() + 2000;
  };

  // 필터 패널이 닫혀있던 경우, 잠깐 동안 자동 오픈 감지(watchUnexpectedOpen)를 무시하게 설정
  function suppressIfClosed() {
    var filters = document.querySelector(selectors.filters);
    var wasVisible = !!(filters && filters.classList.contains(visibleClass));
    if (!wasVisible) window.ohrSuppressFiltersAutoOpen();
  }

  // 모바일에서 필터 패널이 의도치 않게(억제 시간 이후) 열리면 강제로 다시 닫아주는 감시자
  function watchUnexpectedOpen() {
  var filters = document.querySelector(selectors.filters);
  if (!filters) return;

  new MutationObserver(function () {
    if (isDesktop()) return;
    if (Date.now() > suppressUntil) return;
    if (!filters.classList.contains(visibleClass)) return;

    suppressUntil = 0;

    // 클래스를 강제로 제거하지 않고
    // 테마의 실제 닫기 버튼을 실행해서 정상적인 close 로직을 태움
    setTimeout(function () {
      var closeButton = document.querySelector(selectors.closeButton);

      if (closeButton) {
        closeButton.click();
      }
    }, 0);

  }).observe(filters, {
    attributes: true,
    attributeFilter: ['class']
  });
}
  // 적용된 필터 개수를 세어 sticky bar에 표시하고, 개수가 많으면 스타일 클래스 토글
  function updateActiveFiltersCount() {
    var source = document.querySelector(selectors.source);
    var stickyBar = document.querySelector(selectors.stickyBar);
    if (!source || !stickyBar) return;
    var count = source.querySelectorAll('.filter__active__remove').length;
    stickyBar.setAttribute('data-active-filters-count', count);
    stickyBar.classList.toggle(manyFiltersClass, count >= manyFiltersThreshold);
  }

  // 원본 필터 리스트(source)의 HTML을 mirror 요소들에 복사하고, 카운트/드래그스크롤 상태도 갱신
  function syncMirror() {
    var source = document.querySelector(selectors.source);
    var mirrors = document.querySelectorAll(selectors.mirror);
    if (source && mirrors.length) {
      mirrors.forEach(function (mirror) {
        mirror.innerHTML = source.innerHTML;
        mirror.querySelectorAll('[data-filter-reset-button], [data-filter-tag-reset-button]').forEach(function (el) {
          el.removeAttribute('data-filter-reset-button');
          el.removeAttribute('data-filter-tag-reset-button');
        });
      });
    }

    updateActiveFiltersCount();
    updateMirrorDragScrollable();
  }

  // mirror(복사본) 칩 클릭 시, 실제 원본 필터의 동일한 링크를 찾아 대신 클릭시킴
  function onMirrorClick(event) {
    if (event.__ohrSuppressChipClick) return;

    var link = event.target.closest('a');
    if (!link) return;

    event.preventDefault();

    var source = document.querySelector(selectors.source);
    if (!source) return;

    var match = Array.prototype.find.call(source.querySelectorAll('a'), function (a) {
      return a.href === link.href;
    });
    if (!match) return;

    suppressIfClosed();
    match.click();
  }
  var mirrorDrag = null;

  // mirror 칩 목록이 넘쳐서 가로 스크롤이 필요한 상태인지 판별해 클래스 부여
  function updateMirrorDragScrollable() {
    document.querySelectorAll(selectors.filtersClearAll).forEach(function (mirror) {
      mirror.classList.toggle('is-drag-scrollable', mirror.scrollWidth > mirror.clientWidth);
    });
  }

  // mirror 칩 영역에서 드래그 스크롤 시작점(시작 X좌표, 스크롤 위치) 기록
  function onMirrorMouseDown(event) {
    var mirror = event.currentTarget;
    if (mirror.scrollWidth <= mirror.clientWidth) return;

    mirrorDrag = {
      startX: event.clientX,
      startScrollLeft: mirror.scrollLeft,
      moved: false,
    };
  }

  // 드래그 중 마우스 이동량만큼 mirror 칩 목록을 가로로 스크롤
  function onMirrorMouseMove(event) {
    if (!mirrorDrag) return;

    var mirror = event.currentTarget;
    var delta = event.clientX - mirrorDrag.startX;
    if (!mirrorDrag.moved && Math.abs(delta) < 5) return;

    if (!mirrorDrag.moved) {
      mirrorDrag.moved = true;
      mirror.classList.add('is-dragging');
    }

    event.preventDefault();
    mirror.scrollLeft = mirrorDrag.startScrollLeft - delta;
  }

  // 드래그 종료 처리, 실제로 드래그했다면 이어지는 클릭 이벤트를 한 번 무시시킴(오작동 클릭 방지)
  function onMirrorDragEnd(event) {
    if (!mirrorDrag) return;

    var mirror = event.currentTarget;
    var wasDragging = mirrorDrag.moved;
    mirror.classList.remove('is-dragging');
    mirrorDrag = null;

    if (!wasDragging) return;

    var onceClick = function (clickEvent) {
      clickEvent.__ohrSuppressChipClick = true;
    };
    mirror.addEventListener('click', onceClick, {capture: true, once: true});
    setTimeout(function () {
      mirror.removeEventListener('click', onceClick, {capture: true});
    }, 0);
  }
  // 원본 필터 영역의 DOM 변경을 감지해 mirror 동기화 및 드래그 바인딩을 재실행
  function watchFiltersContentChange() {
    var filters = document.querySelector(selectors.filters);
    if (!filters) return;

    new MutationObserver(function () {
      syncMirror();
      bindMirrorDrag();
    }).observe(filters, {childList: true, subtree: true});
  }

  // mirror 칩 요소들에 드래그 스크롤용 이벤트 리스너(mousedown/move/up 등)를 중복 없이 바인딩
  function bindMirrorDrag() {
    document.querySelectorAll(selectors.filtersClearAll).forEach(function (mirror) {
      if (mirror.dataset.dragBound) return;
      mirror.dataset.dragBound = 'true';

      mirror.addEventListener('mousedown', onMirrorMouseDown);
      mirror.addEventListener('mousemove', onMirrorMouseMove);
      mirror.addEventListener('mouseup', onMirrorDragEnd);
      mirror.addEventListener('mouseleave', onMirrorDragEnd);
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(updateMirrorDragScrollable).observe(mirror);
      }
    });
  }
  // filter box 영역을 테마의 스크롤락(ScrollLock) 예외 대상(스크롤 가능 영역)으로 등록
  function registerFilterBoxAsScrollable() {
    if (window.themeVendor && themeVendor.ScrollLock && themeVendor.ScrollLock.addScrollableSelector) {
      themeVendor.ScrollLock.addScrollableSelector(selectors.filterBox);
      themeVendor.ScrollLock.addScrollableSelector('.collection__filters__clear');
    }
  }

  // 하단 고정 박스(filterBottomBox) 높이를 측정해 filter box의 하단 여백 CSS 변수에 반영
  function syncFilterBoxBottomSpace() {
    var bottomBox = document.querySelector(selectors.filterBottomBox);
    var filterBox = document.querySelector(selectors.filterBox);
    if (!bottomBox || !filterBox) return;

    filterBox.style.setProperty('--filter-bottom-box-h', Math.ceil(bottomBox.getBoundingClientRect().height) + 'px');
  }

  // 하단 고정 박스 크기 변화를 감시해 syncFilterBoxBottomSpace를 자동 재실행
  function watchFilterBottomBoxSize() {
    var bottomBox = document.querySelector(selectors.filterBottomBox);
    if (!bottomBox || typeof ResizeObserver === 'undefined') return;

    new ResizeObserver(syncFilterBoxBottomSpace).observe(bottomBox);
  }
  var measurer = null;

  // select 텍스트 폭 측정용 숨김 span(measurer)을 만들고 select와 같은 폰트 스타일로 맞춤
  function getMeasurer(select) {
    if (!measurer) {
      measurer = document.createElement('span');
      measurer.style.cssText = 'position:absolute;left:-9999px;top:0;white-space:pre;visibility:hidden;pointer-events:none;';
      document.body.appendChild(measurer);
    }

    var computed = getComputedStyle(select);
    measurer.style.fontFamily = computed.fontFamily;
    measurer.style.fontSize = computed.fontSize;
    measurer.style.fontWeight = computed.fontWeight;
    measurer.style.letterSpacing = computed.letterSpacing;

    return measurer;
  }

  // 선택된 옵션 텍스트 길이에 맞춰 select 요소의 width를 동적으로 조정
  function autosizeSelect(select) {
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var span = getMeasurer(select);
    span.textContent = option.text;

    var computed = getComputedStyle(select);
    var extra =
      (parseFloat(computed.paddingLeft) || 0) +
      (parseFloat(computed.paddingRight) || 0) +
      (parseFloat(computed.borderLeftWidth) || 0) +
      (parseFloat(computed.borderRightWidth) || 0);

    select.style.width = Math.ceil(span.offsetWidth + extra) + 'px';
  }

  // 상단 정렬바(sortBar) 값이 바뀌면 드로어(sortDrawer)와 실제 필터 폼에도 값/이벤트를 동기화
  function onSortBarChange(event) {
    var drawer = document.querySelector(selectors.sortDrawer);
    var form = document.querySelector(selectors.nativeForm);
    autosizeSelect(event.target);
    if (!drawer || !form) return;

    suppressIfClosed();

    drawer.value = event.target.value;
    form.dispatchEvent(new Event('input', {bubbles: true}));
  }

  // 드로어(sortDrawer)의 정렬 값이 바뀌면 상단 정렬바(sortBar)에도 값을 반영하고 크기 재조정
  function onSortDrawerChange(event) {
    var bar = document.querySelector(selectors.sortBar);
    if (!bar) return;

    bar.value = event.target.value;
    autosizeSelect(bar);
  }

  // 정렬 드로어에 change 이벤트 리스너를 (중복 방지 후) 바인딩
  function bindSortDrawer() {
    var drawer = document.querySelector(selectors.sortDrawer);
    if (!drawer) return;

    drawer.removeEventListener('change', onSortDrawerChange);
    drawer.addEventListener('change', onSortDrawerChange);
  }
  // 데스크탑에서 필터 토글 버튼 클릭 시 필터 패널을 열고 닫으며 스크롤 락/언락 이벤트 발생
  function onDocumentClickForDesktopToggle(event) {
    if (!isDesktop()) return;

    var toggle = event.target.closest(selectors.toggle);
    if (!toggle) return;

    var filters = document.querySelector(selectors.filters);
    if (!filters) return;
    event.preventDefault();
    event.stopPropagation();

    var isOpen = filters.classList.contains(visibleClass);
    filters.classList.toggle(visibleClass, !isOpen);

    if (isOpen) {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true, detail: 300}));
    } else {
      var scrollableList = document.querySelector(selectors.filtersList);
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableList}));
    }
  }
  // 오버레이(배경) 클릭 시 닫기 버튼을 대신 클릭시켜 필터 패널을 닫음
  function onDocumentClickForOverlay(event) {
    if (!event.target.closest(selectors.overlay)) return;

    var closeButton = document.querySelector(selectors.closeButton);
    if (closeButton) closeButton.click();
  }

  // data-single-select가 붙은 필터 그룹(예: 커스텀 필터)은 체크박스를 그대로 쓰되,
  // 하나를 체크하면 같은 name(=같은 필터 그룹)을 가진 나머지는 강제로 해제해서
  // 단일선택처럼 동작하게 함. 체크박스 자체 동작(다시 눌러서 해제 등)은 그대로 유지됨.
  function onDocumentChangeForSingleSelectFilter(event) {
    var input = event.target;
    if (!input.matches('.filter__input[data-single-select]')) return;

    if (input.checked) {
      document.querySelectorAll('.filter__input[data-single-select][name="' + CSS.escape(input.name) + '"]').forEach(function (other) {
        if (other !== input && other.checked) other.checked = false;
      });
    }

    // 독립형 커스텀 필터 섹션(assets/custom-filter.js)이 같은 파라미터명으로 만들어둔
    // 체크박스/hidden mirror가 있으면 값까지 맞춰서 동기화합니다: 지금 선택된 값이면
    // 체크, 아니면 해제. 두 UI가 서로 다른 값을 동시에 들고 있지 않게 맞춰줍니다.
    document.querySelectorAll('[data-custom-filter-input][data-param-name="' + CSS.escape(input.name) + '"]').forEach(function (customInput) {
      customInput.checked = input.checked && customInput.getAttribute('data-value') === input.value;
    });
    var form = input.closest('form') || document.querySelector('[data-collection-filters-form]');
    if (form) {
      form.querySelectorAll('input[type="hidden"][data-custom-filter-mirror="' + CSS.escape(input.name) + '"]').forEach(function (mirror) {
        if (!input.checked || mirror.value !== input.value) mirror.remove();
      });
    }
  }

  // 진입점: 위의 동기화/감시 함수들과 이벤트 리스너들을 최초 1회 초기화
  function init() {
    syncMirror();

    document.querySelectorAll(selectors.mirror).forEach(function (mirror) {
      mirror.addEventListener('click', onMirrorClick);
    });
    bindMirrorDrag();

    var sortBar = document.querySelector(selectors.sortBar);
    if (sortBar) {
      sortBar.addEventListener('change', onSortBarChange);
      autosizeSelect(sortBar);
    }
    bindSortDrawer();

    watchUnexpectedOpen();
    watchFiltersContentChange();
    registerFilterBoxAsScrollable();
    syncFilterBoxBottomSpace();
    watchFilterBottomBoxSize();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('theme:filters:init', syncMirror);
  document.addEventListener('theme:filters:init', bindSortDrawer);
  document.addEventListener('theme:filters:init', syncFilterBoxBottomSpace);
  document.addEventListener('theme:filters:init', bindMirrorDrag);
  document.addEventListener('click', onDocumentClickForDesktopToggle, true);
  document.addEventListener('click', onDocumentClickForOverlay);
  document.addEventListener('change', onDocumentChangeForSingleSelectFilter);
})();
